import { StyleSheet, css } from 'aphrodite'
import AddContactsTable from '../components/contact/AddContactsTable'

export const ContactsPage: React.FC = () => {
  return (
    <div className={css(styles.contactsDashboard)}>
      <div className={css(styles.mainContent)}>
        <AddContactsTable />
      </div>
    </div>
  )
}

const styles = StyleSheet.create({
  contactsDashboard: {
    display: 'flex',
    padding: '16px',
    backgroundColor: '#F9FAFB',
    minHeight: '100vh',
    width: 'calc(100vw - 280px)',
    boxSizing: 'border-box',
    overflowX: 'hidden',
    '@media (max-width: 1024px)': {
      padding: '12px',
      width: '100vw',
    },
  },
  mainContent: {
    flex: 1,
    width: '100%',
    boxSizing: 'border-box',
  },
})
